import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=0476700a&scoped=true"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"
import style0 from "./Guest.vue?vue&type=style&index=0&id=0476700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476700a",
  null
  
)

export default component.exports